/**
 * Dashboard Internationalization - English
 */
export default {
  'dashboard.title': 'Garbage Room Management',
  'dashboard.subtitle': 'Real-time monitoring of garbage room status',
  
  // Statistics Cards
  'dashboard.statistics.totalRooms': 'Total Rooms',
  'dashboard.statistics.totalRooms.desc': 'Currently operating garbage rooms',
  'dashboard.statistics.totalPorts': 'Total Ports',
  'dashboard.statistics.totalPorts.desc': 'Total number of delivery ports',
  'dashboard.statistics.overflowPorts': 'Overflow Ports',
  'dashboard.statistics.overflowPorts.desc': 'Require immediate attention',
  'dashboard.statistics.normalPorts': 'Normal Ports',
  'dashboard.statistics.normalPorts.desc': 'Operating normally',
  
  // Table Columns
  'dashboard.table.name': 'Name',
  'dashboard.table.name.placeholder': 'Enter garbage room name',
  'dashboard.table.tvocLevel': 'TVOC Level',
  'dashboard.table.overflowCount': 'Overflow Count',
  'dashboard.table.normalCount': 'Normal Count',
  'dashboard.table.deodorizerStatus': 'Deodorizer Status',
  'dashboard.table.uvLightStatus': 'UV Light Status',
  'dashboard.table.action': 'Action',
  'dashboard.table.action.detail': 'Detail',
  
  // Status
  'dashboard.status.on': 'On',
  'dashboard.status.off': 'Off',
  
  // Detail Drawer
  'dashboard.detail.title': 'Garbage Room Detail',
  'dashboard.detail.basicInfo': 'Basic Information',
  'dashboard.detail.name': 'Room Name',
  'dashboard.detail.tvocLevel': 'TVOC Level',
  'dashboard.detail.overflowCount': 'Overflow Count',
  'dashboard.detail.normalCount': 'Normal Count',
  'dashboard.detail.deodorizerStatus': 'Deodorizer Status',
  'dashboard.detail.uvLightStatus': 'UV Light Status',
  'dashboard.detail.address': 'Address',
  'dashboard.detail.portsInfo': 'Port Status',
  'dashboard.detail.portsList': 'Port List',
  
  // Messages
  'dashboard.message.controlSuccess': 'Operation successful',
  'dashboard.message.controlFailed': 'Operation failed',
  'dashboard.message.getDetailFailed': 'Failed to get details',
  'dashboard.message.deodorizerOn': 'Deodorizer turned on',
  'dashboard.message.deodorizerOff': 'Deodorizer turned off',
  'dashboard.message.uvLightOn': 'UV light turned on',
  'dashboard.message.uvLightOff': 'UV light turned off',
}

